import { Get } from "../../../api/apiHelper";
import { ServiceProvider } from "../../../interfaces/ServiceProvidersInterface";

const departmentSpRoot = "/api/departmentServiceProviders";

export const getDepartmentSp = async (): Promise<Array<ServiceProvider>> => {
  const response = await Get(departmentSpRoot);
  return response.data as Array<ServiceProvider>;
};

export default getDepartmentSp;
